import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
`;

export const StyledSchedulingTimesWrapper = styled.div`
  flex: 1;
  overflow: auto;
  white-space: nowrap;
`;

export const StyledDeliveryTimesWrapper = styled.div`
  padding: ${({ theme }) => `${theme.space[4]}px ${theme.space[6]}px 0`};
  background: ${({ theme }) => `${theme?.colors?.negative?.absolute}`};
`;

export const StyledPrefix = styled.div`
  width: 100%;
  text-align: center;
  color: ${props => props.theme.color.bodyText};
  white-space: nowrap;
`;
